<script setup lang="ts" name="XTitle"></script>

<template>
  <h2 class="font-body text-lg font-bold leading-5 text-secondary-9">
    <slot />
  </h2>
</template>
